export const MAILING_JOBS_LOAD = 'MAILING_JOBS_LOAD';
export const MAILING_JOBS_LOAD_SUCCESS = 'MAILING_JOBS_LOAD_SUCCESS';
export const MAILING_JOBS_LOAD_ERROR = 'MAILING_JOBS_LOAD_ERROR';
export const MAILING_JOBS_ADD = 'MAILING_JOBS_ADD';
export const MAILING_JOBS_ADD_SUCCESS = 'MAILING_JOBS_ADD_SUCCESS';
export const MAILING_JOBS_ADD_ERROR = 'MAILING_JOBS_ADD_ERROR';
export const MAILING_JOBS_UPDATE = 'MAILING_JOBS_UPDATE';
export const MAILING_JOBS_UPDATE_SUCCESS = 'MAILING_JOBS_UPDATE_SUCCESS';
export const MAILING_JOBS_UPDATE_ERROR = 'MAILING_JOBS_UPDATE_ERROR';
export const MAILING_JOBS_DELETE = 'MAILING_JOBS_DELETE';
export const MAILING_JOBS_DELETE_SUCCESS = 'MAILING_JOBS_DELETE_SUCCESS';
export const MAILING_JOBS_DELETE_ERROR = 'MAILING_JOBS_DELETE_ERROR';
